export default __webpack_public_path__ + "static/media/No.7-2.f27d4c37.jpg";